import p1 from '@/assets/img/gallery/portfolio-01/portfolio-01.jpg'
import p2 from '@/assets/img/gallery/portfolio-01/portfolio-02.jpg'
import p3 from '@/assets/img/gallery/portfolio-01/portfolio-03.jpg'

import pp1 from '@/assets/img/pulman/pulman1(1).png'
import pp2 from '@/assets/img/zodiac/Zodiac2.png'
import pp3 from '@/assets/img/phoenix/phoenix3.png'
import pp4 from '@/assets/img/neonPigeon/NEON2.png'
import pp5 from '@/assets/img/acta/acta5.png'
import pp6 from '@/assets/img/black-pond/black-pond(1).png'

import pp7 from '@/assets/img/Ambrosia-Private-Club/Screenshot(152).png'
import pp7_1 from '@/assets/img/Ambrosia-Private-Club/Screenshot(141).png'
import pp7_2 from '@/assets/img/Ambrosia-Private-Club/Screenshot(142).png'
import pp7_3 from '@/assets/img/Ambrosia-Private-Club/Screenshot(143).png'
import pp7_4 from '@/assets/img/Ambrosia-Private-Club/Screenshot(144).png'
import pp7_5 from '@/assets/img/Ambrosia-Private-Club/Screenshot(153).png'
import pp7_6 from '@/assets/img/Ambrosia-Private-Club/Screenshot(203).png'
import pp7_7 from '@/assets/img/Ambrosia-Private-Club/Screenshot(204).png'






import pp8 from '@/assets/img/Brew&Co/Screenshot(212).png'
import pp8_1 from '@/assets/img/Brew&Co/Screenshot(213).png'
import pp8_2 from '@/assets/img/Brew&Co/Screenshot(214).png'
import pp8_3 from '@/assets/img/Brew&Co/Screenshot(215).png'
import pp8_4 from '@/assets/img/Brew&Co/Screenshot(216).png'
import pp8_5 from '@/assets/img/Brew&Co/Screenshot(217).png'
import pp8_6 from '@/assets/img/Brew&Co/Screenshot(218).png'
import pp8_7 from '@/assets/img/Brew&Co/Screenshot(219).png'
import pp8_8 from '@/assets/img/Brew&Co/Screenshot(220).png'





import pp9 from '@/assets/img/LOLA-Espiritu-Bar/Screenshot(208).png'
import pp9_1 from '@/assets/img/LOLA-Espiritu-Bar/Screenshot(207).png'
import pp9_2 from '@/assets/img/LOLA-Espiritu-Bar/Screenshot(209).png'




import pp10 from '@/assets/img/Maison-De-Wisteria/Screenshot(38).png'
import pp10_1 from '@/assets/img/Maison-De-Wisteria/Screenshot(37).png'


import pp11 from '@/assets/img/Paris-Baguette/Screenshot(36).png'


import tpp1 from '@/assets/img/pulman/pulman2.png'
import tpp2 from '@/assets/img/zodiac/Zodiac1.png'
import tpp3 from '@/assets/img/phoenix/phoenix1.png'
// import tpp3_1 from '@/assets/img/phoenix/phoenix2.png'
import tpp4_1 from '@/assets/img/acta/acta1.png'
import tpp4_2 from '@/assets/img/acta/acta2.png'
import tpp4_3 from '@/assets/img/acta/acta3.png'
import tpp4_4 from '@/assets/img/acta/acta4.png'


import tpp5_1 from '@/assets/img/neonPigeon/NEON1.png'
import tpp6_1 from '@/assets/img/black-pond/black.png'


export const portfolioOne = [
    {
        id:1,
        image:p1,
        tag:'Classic Chair',
        name:'Classic Vase & Chair'
    },
    {
        id:2,
        image:p2,
        tag:'Art Design',
        name:'Classic Vase & Chair'
    },
    {
        id:3,
        image:p3,
        tag:'Design',
        name:'Classic Vase & Chair'
    },
    {
        id:4,
        image:p1,
        tag:'Vase',
        name:'Classic Vase & Chair'
    },
    {
        id:5,
        image:p2,
        tag:'Art',
        name:'Classic Vase & Chair'
    },
]

export const portfolioTwo = [
    {
        id:1,
        image:pp1,
        category: ["Sofa", "Interior"],
        tag:'Custom all furniture',
        name:'PULLMAN Hotel Orchard Singapore 2023'
    },
    {
        id:2,
        image:pp2,
        category:['Interior'],
        tag:'Custom all furniture',
        name:'ZODIAC'
    },
    {
        id:3,
        image:pp3,
        category:['Vase','Sofa'],
        tag:'Custom all furniture',
        name:'Phoenix Gastro Bar - PIK'
    },
    {
        id:4,
        image:pp5,
        category:['Design'],
        tag:'Custom all furniture',
        name:'ACTA Brasserie (The MAJ, Senayan)'
    },
    {
        id:5,
        image:pp4,
        category:['Table'],
        tag:'Custom all furniture',
        name:'Neon Pigeon – Singapore 2023'
    },

    {
        id:6,
        image:pp6,
        category:["Interior", "Vase"],
        tag:'Custom all furniture',
        name:'Black Pond Tavern The MAJ  Senayan'
    },
    {
        id:7,
        image:pp7,
        category:["Interior", "Vase"],
        tag:'Custom all furniture',
        name:'Ambrosia Private Club'
    },
    {
        id:8,
        image:pp8,
        category:["Interior", "Vase"],
        tag:'Custom all furniture',
        name:'Brew&Co'
    },
    {
        id:9,
        image:pp9,
        category:["Interior", "Vase"],
        tag:'Custom all furniture',
        name:'Lola Espiritu Bar'
    },
    {
        id:10,
        image:pp10,
        category:["Interior", "Vase"],
        tag:'Custom all furniture',
        name:'Maison De Wisteria'
    },
    {
        id:11,
        image:pp11,
        category:["Interior", "Vase"],
        tag:'Custom all furniture',
        name:'Paris Baguette'
    },
]





export const testimonialTwo = [
    {
        id:1,
        image:[tpp1],
    },
    {
        id:2,
        image:[tpp2],
    },
    {
        id:3,
        image:[tpp3],  
    },
    {
        id:4,
        image:[ tpp4_1 , tpp4_2  ,tpp4_3 , tpp4_4],

    },
    {
        id:5,
        image:[tpp5_1],

    },

    {
        id:6,
        image:[tpp6_1],
    },
    {
        id: 7,
        image:[pp7_1, pp7_2, pp7_3, pp7_4, pp7_5, pp7_6, pp7_7],
    },
    {
        id: 8,
        image:[pp8_1, pp8_2, pp8_3, pp8_4, pp8_5, pp8_6, pp8_7, pp8_8],
    },
    {
        id: 9,
        image:[pp9_1, pp9_2],
    },
    {
        id: 10,
        image:[pp10_1],
    },
]